'use client';
import React, { useState } from 'react';
import { stores } from './storeData';
import MapPlaceholder from './MapPlaceholder';
import StoreCard from './StoreCard';
import StoreDetailPanel from './StoreDetailPanel';
import type { Store } from './storeData';
import Icon from '@/components/ui/AppIcon';

export default function StoreLocatorClient() {
  const [search, setSearch] = useState('');
  const [selectedStore, setSelectedStore] = useState<Store | null>(null);
  const [filterDriveThru, setFilterDriveThru] = useState(false);
  const [filterOpenNow, setFilterOpenNow] = useState(false);

  const filtered = stores.filter((s) => {
    const q = search.toLowerCase();
    if (q && !s.name.toLowerCase().includes(q) && !s.district.toLowerCase().includes(q)) return false;
    if (filterDriveThru && !s.driveThru) return false;
    if (filterOpenNow && s.status === 'closed') return false;
    return true;
  });

  return (
    <div>
      {/* Search bar */}
      <div className="px-4 py-3 bg-card border-b border-border sticky top-[56px] z-30">
        <div className="relative mb-3">
          <Icon name="MagnifyingGlassIcon" size={18} className="absolute left-3 top-1/2 -translate-y-1/2 text-muted-foreground" />
          <input
            type="text"
            placeholder="Semt veya mağaza ara..."
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            className="w-full bg-input border border-border rounded-xl pl-10 pr-4 py-3 text-foreground text-sm placeholder:text-muted-foreground focus:outline-none focus:ring-2 focus:ring-primary/30"
          />
          {search && (
            <button onClick={() => setSearch('')} className="absolute right-3 top-1/2 -translate-y-1/2">
              <Icon name="XMarkIcon" size={16} className="text-muted-foreground" />
            </button>
          )}
        </div>

        {/* Filters */}
        <div className="flex gap-2">
          <button
            onClick={() => setFilterOpenNow(!filterOpenNow)}
            className={`flex items-center gap-1.5 px-3 py-1.5 rounded-full text-xs font-semibold border transition-all ${
              filterOpenNow ? 'bg-primary text-white border-primary' : 'bg-card text-muted-foreground border-border hover:border-primary/50'
            }`}
          >
            <Icon name="ClockIcon" size={12} className={filterOpenNow ? 'text-white' : 'text-muted-foreground'} />
            Şu An Açık
          </button>
          <button
            onClick={() => setFilterDriveThru(!filterDriveThru)}
            className={`flex items-center gap-1.5 px-3 py-1.5 rounded-full text-xs font-semibold border transition-all ${
              filterDriveThru ? 'bg-primary text-white border-primary' : 'bg-card text-muted-foreground border-border hover:border-primary/50'
            }`}
          >
            🚗 Drive-Thru
          </button>
          <span className="ml-auto text-muted-foreground text-xs self-center">{filtered.length} mağaza</span>
        </div>
      </div>

      {/* Map */}
      <MapPlaceholder stores={filtered} selectedStore={selectedStore} onSelectStore={setSelectedStore} />

      {/* Store list */}
      <div className="px-4 py-3">
        <h2 className="text-foreground font-bold text-sm mb-3">Yakındaki Mağazalar</h2>
        {filtered.length === 0 ? (
          <div className="flex flex-col items-center py-10 text-center">
            <Icon name="MapPinIcon" size={40} className="text-muted-foreground mb-2" />
            <p className="text-foreground font-semibold mb-1">Mağaza bulunamadı</p>
            <p className="text-muted-foreground text-sm">Farklı bir arama terimi veya filtre deneyin</p>
          </div>
        ) : (
          <div className="space-y-3">
            {filtered.map((store) => (
              <StoreCard
                key={store.id}
                store={store}
                selected={selectedStore?.id === store.id}
                onClick={() => setSelectedStore(selectedStore?.id === store.id ? null : store)}
              />
            ))}
          </div>
        )}
      </div>

      {/* Detail panel */}
      {selectedStore && (
        <StoreDetailPanel store={selectedStore} onClose={() => setSelectedStore(null)} />
      )}
    </div>
  );
}